export default __webpack_public_path__ + "static/Canadas_rising_Inuit_TikTok_star-7fc6226f4df304eb6e73ed4ed8ad270d.jpg";